import * as efiauth from 'libs/efiauth';
import { instanceWithToken } from '@auth/api/skeleton';

const axios = instanceWithToken;

const request = async (requester) => {
  try {
    const res = await requester();
    return res.data.data;
  } catch (err) {
    if (err.response) {
      err.message = `Error HTTP ${err.response.status}`;
      if (err.response.status === 401) {
        efiauth.doLogout();
      }
    }
    throw err;
  }
};

export const fetchLeadProfile = async () => {
  return request(() => axios.get(`${process.env.REACT_APP_BACKEND_URL}/leads`));
};

export const fetchSummary = async () => {
  return request(() => axios(`${process.env.REACT_APP_BACKEND_URL}/summary`));
};

export const fetchBlockList = async () => {
  return request(() =>
    axios(`${process.env.REACT_APP_BACKEND_URL}/summary/block`)
  );
};

export const fetchAllBlock = async (params) => {
  return request(() =>
    axios(`${process.env.REACT_APP_BACKEND_URL}/summary/blocks`, {
      ...(params && { params })
    })
  );
};

export const fetchAllPonds = async (blockName) => {
  return request(() =>
    axios(`${process.env.REACT_APP_BACKEND_URL}/summary/block/${blockName}`)
  );
};

export const fetchPonds = async (pondName) => {
  return request(() =>
    axios(`${process.env.REACT_APP_BACKEND_URL}/summary/pond/${pondName}`)
  );
};

export const fetchCycle = async (cycleId) => {
  return request(() =>
    axios(`${process.env.REACT_APP_BACKEND_URL}/cycles/${cycleId}`)
  );
};

export const postDevices = async (lead_id, device_token) => {
  return request(() =>
    axios.post(`${process.env.REACT_APP_BACKEND_URL}/leads/devices`, {
      lead_id,
      device_token
    })
  );
};

export const patchSwitchInternalMode = async () => {
  return request(() =>
    axios.patch(`${process.env.REACT_APP_BACKEND_URL}/fbd/internal-mode`)
  );
};
